import { AbilityContext } from "components/Permissions/Can"
import { useContext, useMemo } from "react"

const useSegmentTypeOptions = ({ isLearningCenter = false } = {}) => {
    const ability = useContext(AbilityContext)
    const canReadLearningCenters = ability.can("read", "learning_center")

    const segmentTypeOptions = useMemo(() => [
        { id: "affiliation", name: "בתי ספר" },
        { id: "city", name: "ערים" },
        { id: "grade", name: "שכבות" },
        { id: "class", name: "כיתות" },
        { id: "rating", name: "דירוגים" },
        { id: "gender", name: "מגדר" },
        { id: "language", name: "שפת אם" },
        { id: "immigrant", name: "עולים" },
        ...(isLearningCenter ? [{ id: "home_affiliation", name: "בתי ספר אם" }] : []),
    ], [canReadLearningCenters, isLearningCenter])

    const learningCenter = { id: "learning_center", name: "מרכזי למידה" }

    return segmentTypeOptions
}

const useAllSegmentTypeOptions = () => {
    const ability = useContext(AbilityContext)
    const canReadLearningCenters = ability.can("read", "learning_center")

    const segmentTypeOptions = useSegmentTypeOptions()

    const allSegmentTypeOptions = useMemo(() => [
        ...segmentTypeOptions,
        { id: "category", name: "קטגוריות" }
    ], [canReadLearningCenters])

    return allSegmentTypeOptions
}

export { useSegmentTypeOptions, useAllSegmentTypeOptions }